var _style, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _path6, _path7, _path8, _path9, _path0, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDogeWalkerBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 749.8 675.3",
    style: {
      enableBackground: "new 0 0 749.8 675.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5D1AC;}\n\t.st1{fill:#423223;}\n\t.st2{fill:#947151;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#3E4347;}\n\t.st5{fill:#7D644B;}\n\t.st6{fill:#F15A61;}\n\t.st7{fill:#BA454B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.4,589.1c-85-55-118.8-268.8-91.2-365c20-72.5,97.5-178.8,167.5-206.2c58.7-23.8,193.8-23.8,251.3,0 c70,27.5,147.5,133.7,167.5,206.2c27.5,97.5,6.2,310-77.5,365C412.4,704.1,349.9,704.1,172.4,589.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.6,246.6c45,98.8,56.3,102.5,98.8-15c22.5-62.5,6.2-100,33.8-140c15-22.5,48.8-60,48.8-60 S-46.4,59.1,38.6,246.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.4,27.8C84.9,71.6-58.9,54.1,26.1,240.3c45,98.8,56.2,102.5,98.8-15c22.5-62.5,6.2-100,33.8-140 c15-22.5,61.2-53.8,61.2-53.8S198.6-2.2,152.4,27.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M711.1,245.3c-45,98.7-56.2,102.5-98.8-15c-22.5-62.5-6.2-100-33.8-140c-15-22.5-48.8-60-48.8-60 S796.1,59.1,711.1,245.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M597.4,27.8c67.5,43.7,211.2,26.2,126.3,212.5c-45,98.8-56.2,102.5-98.8-15c-22.5-62.5-6.2-100-33.8-140 c-15-22.5-61.2-53.8-61.2-53.8S551.1-2.2,597.4,27.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 196.1,
    cy: 321.6,
    r: 75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 177.4,
    cy: 321.6,
    r: 56.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 553.6,
    cy: 321.6,
    r: 75
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 572.4,
    cy: 321.6,
    r: 56.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M246.1,547.8l57.5,61.2c35,36.3,106.3,36.3,141.2,0l58.8-61.2l-60-62.5H306.1L246.1,547.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.9,432.8c0,0-61.2,87.5-53.8,128.8c10,60,96.2,60,107.5,0C436.1,520.3,374.9,432.8,374.9,432.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M374.9,584.1l13.7-83.8h-27.5L374.9,584.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.4,456.6h125v57.5h-125V456.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M572.4,470.3l-88.7-93.8c-53.8-56.2-163.8-56.2-217.5,0l-88.8,93.8c-25,26.2-25,70,0,96.2 c25,26.2,66.2,26.2,91.2,0l88.8-93.8c8.8-8.8,25-8.8,33.7,0l88.8,93.8c25,26.2,66.2,26.2,91.2,0 C598.6,540.3,598.6,496.6,572.4,470.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.1,384.1c0-32.5,32.5-38.7,73.8-38.7s73.8,6.2,73.8,38.7c0,26.2-58.8,48.8-73.8,48.8 C359.9,432.8,301.1,409.1,301.1,384.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266.3,425.5l12.4-12.4l12.4,12.4l-12.4,12.4L266.3,425.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M236.7,460.5l12.4-12.4l12.4,12.4l-12.4,12.4L236.7,460.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M276.4,472.4l12.4-12.4l12.4,12.3l-12.4,12.4L276.4,472.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M458.7,425.2l12.4-12.4l12.4,12.4L471,437.6L458.7,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M489,459.8l12.4-12.4l12.3,12.4l-12.4,12.4L489,459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M449.2,473l12.4-12.3L474,473l-12.4,12.4L449.2,473z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogeWalkerBadge);
export default __webpack_public_path__ + "static/media/doge_walker_badge.49a86fc6cace5370ccb4388c8b9a0cf6.svg";
export { ForwardRef as ReactComponent };